// Base URL for our Netlify Functions API.
// Defaults to the local Netlify Dev proxy on :8888 (the rewrite in
// netlify.toml maps /api/* → /.netlify/functions/*). For non-default
// setups (production, alternate ports), override with REACT_APP_API_BASE_URL
// in frontend/.env. Exported so components can build absolute URLs without
// depending on relative-path proxying (which breaks on :3000).
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:8888/api';
